<template>
  <div class="qanda-card">
    <div class="card-head flex-between" v-if="app === 'teacher'">
      <span class="title">家长回评</span>
      <span class="flex-center small"
        >平均得分：<span class="score">{{ avg }}</span></span
      >
    </div>
    <div class="card-head" v-if="app === 'parent'">
      <template v-if="isEdit">
        <div class="title">对老师进行评价</div>
        <span class="desc">问下孩子上课感受，给老师评个分吧（{{reviewExpireTime | formatDatetime('yyyy-MM-dd')}}截止）</span>
      </template>
      <template v-else>
        <span class="title">给老师的评价</span>
      </template>
    </div>

    <div class="card-body">
      <div class="score-item flex-between" v-for="(item, index) in list" :key="item.sort">
        <span class="score-title">{{ item.title }}：</span>
        <div class="shapes">
          <van-icon
            v-for="score in [1, 2, 3, 4, 5]"
            :key="score"
            class="icon"
            class-prefix="vxs-icon"
            name="xing"
            size="24"
            :color="item.value >= score ? '#FAAB0C' : '#C8C9CC'"
            @click="change(index, score)"
          />
        </div>
      </div>
    </div>
    <div class="card-bottom flex-center" v-if="isEdit && app === 'parent'">
      <van-button square round type="primary" size="large" class="btn" @click="submit" :disabled="isDisable"
        >提交评价</van-button
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    app: {
      type: String,
      default: 'teacher',
    },
    /**
     * 问卷:
     *    问卷id和list
     * 如果是编辑,需要参数:
     * 点评详情id:commentRecordId和编辑api, { commentRecordId, editApi }
     * 如果已经回答,需要参数:
     * 答卷id: answerId和答卷api, { answerId, answerApi}
     * 
     */
    params: {
      type: Object,
      required: true,
    },
    reviewExpireTime:{
      type: [String,Number],
    }
  },
  data() {
    return {
      list: [],
      isDisable: false,
    };
  },
  computed: {
    avg() {
      const total = this.list.reduce((prev, cur) => prev + Number(cur.value), 0);
      return (total / this.list.length).toFixed(1);
    },
  },
  methods: {
    change(index, score) {
      if (this.isEdit) {
        this.list[index].value = score;
      }
    },
    submit() {
      if (this.isDisable) {
        return;
      }
      if (this.list.some(item=>item.value < 1)) {
        this.$toast.fail('还有维度未评分，请完成所有评分后提交');
        return;
      }
      this.params
        .editApi({
          commentRecordId: this.params.commentRecordId,
          answer: {
            qandaId: this.params.qandaId,
            questions: this.list,
          },
        })
        .then(res => {
          this.$toast.success('提交成功');
          this.isDisable = true;
        });
    },
  },
  created() {
    if (this.isEdit){
      // this.params.queryApi(this.params.qandaId).then(res => {
      //   res.data.questions.forEach(item => {
      //     item.value = 0;
      //   });
      //   this.list = res.data.questions;
      // });

      this.params.list.forEach(item => {
        item.value = 0;
      });
      this.list = JSON.parse(JSON.stringify(this.params.list));

    } else {
      this.params.answerApi(this.params.answerId, this.params.companyId).then(res => {
        this.list = res.data.questions;
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.qanda-card {
  padding: calc(var(--gap) * 16) calc(var(--gap) * 25) calc(var(--gap) * 16) calc(var(--gap) * 16);
  background: var(--white);
  margin: calc(var(--gap) * 12) 0;
  .card-head {
    .title {
      color: var(--g8);
      font-size: var(--fs-lg);
      line-height: var(--lh-lg);
      font-weight: var(--bold);
    }
    .small{
      font-size:var(--fs-sm);
      line-height:var(--lh-sm);
      color:var(--g6);
    }
    .score {
      font-size: var(--fs-lg);
      line-height: var(--lh-lg);
      color: var(--c4);
    }
    .desc {
      font-size: var(--fs-sm);
      line-height: var(--lh-sm);
      margin-top: calc(var(--gap) * 4);
      color: var(--g6);
    }
  }
  .card-body {
    margin-top: calc(var(--gap) * 26);
    .score-item {
      margin-bottom: calc(var(--gap) * 24);
      .score-title {
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        color: var(--g7);
        margin-bottom: calc(var(--gap) * 10);
        word-break: break-all;
        margin-right:calc(var(--gap) * 12);
      }
      .shapes {
        text-align: center;
        .icon {
          margin: 0 calc(var(--gap) * 7);
        }
      }
    }
  }

  .card-bottom {
    padding: calc(var(--gap) * 8) 0;
    .btn {
      width: calc(var(--w) * 180);
    }
  }
}
</style>